/** Formats a course price, with free courses reading as "Free". */
export const formatPrice = (price, currency = "INR") => {
    const amount = Number(price) || 0
    if (amount <= 0) return "Free"

    try {
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency,
            maximumFractionDigits: 0
        }).format(amount)
    } catch (error) {
        return `${currency} ${amount}`
    }
}
